var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import MessageBubble from './components/message-bubble.vue';
import StepsCollapsible from './components/steps-collapsible.vue';
import SessionSidebar from './components/session-sidebar.vue';
import ConnectionsPanel from './components/connections-panel.vue';
import ModelPanel from './components/model-panel.vue';
import DeepSteps from './components/deep-steps.vue';
import { runUrl, sessionUrl } from './deep-urls';
var AiChatApp = /** @class */ (function (_super) {
    __extends(AiChatApp, _super);
    function AiChatApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.config = null;
        _this.chatHistory = [];
        _this.busy = false;
        _this.currentSessionId = null;
        _this.currentRequestId = null;
        _this.currentAbortController = null;
        _this.pendingSessionTitle = null;
        _this.errorMessage = null;
        _this.inputText = '';
        _this.streamingMessage = null;
        _this.liveSteps = [];
        _this.showTyping = false;
        _this.sessions = { latest: [], favorites: [] };
        _this.clockTick = 0;
        _this.railOpen = false;
        _this.selectedModelId = null;
        // The open conversation's own model when it is no longer selectable (switched off), so
        // the locked dropdown still names it instead of falling back to the first entry.
        _this.sessionModel = null;
        // Every new conversation is a deep one (as in Core 3); "plan first" is chosen while no
        // session is open, on by default, and afterwards shows the session's mode, locked.
        // Conversations from the retired fast mode stay readable but can't be continued.
        _this.planFirst = true;
        _this.pendingFile = null;
        _this.sessionMode = null;
        _this.liveDeepSteps = [];
        // Set while a deep turn is in flight; currentRunId once its run exists.
        _this.deepInFlight = false;
        _this.currentRunId = null;
        _this.stopRequested = false;
        _this.clockInterval = null;
        // Raw text accumulator for the in-progress streamed answer — kept outside Vue's
        // reactivity and flushed into streamingMessage.content via rAF, so a burst of
        // small text_delta frames doesn't re-run markdown parsing on every single one.
        _this.streamBuffer = '';
        _this.streamFlushScheduled = false;
        return _this;
    }
    Object.defineProperty(AiChatApp.prototype, "strings", {
        get: function () {
            return this.config.strings;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AiChatApp.prototype, "pickerModels", {
        get: function () {
            var models = this.config.models;
            var extra = this.sessionModel;
            return extra && !models.some(function (m) { return m.id === extra.id; }) ? __spreadArray(__spreadArray([], models, true), [extra], false) : models;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AiChatApp.prototype, "typingStatus", {
        // Shown next to the typing dots: what the assistant is doing right now.
        get: function () {
            if (this.liveDeepSteps.length) {
                var running = this.liveDeepSteps.filter(function (s) { return s.status === 'running'; });
                var step = running.length ? running[running.length - 1] : null;
                return step ? step.intent : '';
            }
            var last = this.liveSteps.length ? this.liveSteps[this.liveSteps.length - 1] : null;
            return last ? last.label || last.name || '' : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AiChatApp.prototype, "modeLocked", {
        get: function () {
            return this.currentSessionId !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AiChatApp.prototype, "lockedToFast", {
        get: function () {
            return this.modeLocked && (this.sessionMode || 'fast') === 'fast';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AiChatApp.prototype, "deepActive", {
        // Whether the next message runs as a deep investigation: always, except in a conversation
        // left from the retired fast mode, which takes no new messages.
        get: function () {
            return !this.lockedToFast;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AiChatApp.prototype, "planFirstActive", {
        get: function () {
            return this.modeLocked ? this.sessionMode === 'deep_planned' : this.planFirst;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AiChatApp.prototype, "planFirstTitle", {
        get: function () {
            if (this.modeLocked)
                return this.planFirstActive ? this.strings.lockedPlanFirstTitle : this.strings.lockedNoPlanTitle;
            return this.strings.planFirstTitle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AiChatApp.prototype, "attachTitle", {
        get: function () {
            return this.lockedToFast ? this.strings.retiredConversation : this.strings.attachFile;
        },
        enumerable: false,
        configurable: true
    });
    AiChatApp.prototype.chooseFile = function () {
        var input = this.$refs.fileInput;
        if (input)
            input.click();
    };
    AiChatApp.prototype.onFileChosen = function (event) {
        var input = event.target;
        var file = input.files && input.files.length ? input.files[0] : null;
        if (file)
            this.pendingFile = file;
        input.value = '';
    };
    // Take the model (id and name) from a session payload; null id = it predates model
    // selection or its model was deleted, so the picker goes back to the user's default.
    AiChatApp.prototype.applySessionModel = function (data) {
        this.sessionMode = data.mode || 'fast';
        if (data.model_id) {
            this.selectedModelId = data.model_id;
            this.sessionModel = data.model_name ? { id: data.model_id, name: data.model_name } : null;
        }
        else {
            this.selectedModelId = this.initialModelId();
            this.sessionModel = null;
        }
    };
    Object.defineProperty(AiChatApp.prototype, "displayMessages", {
        // The greeting is shown whenever there's no real conversation yet, but it is
        // never added to chatHistory itself — it must not be sent to the backend or
        // persisted to localStorage, matching the original behaviour exactly.
        get: function () {
            if (this.chatHistory.length > 0)
                return this.chatHistory;
            return [
                {
                    role: 'assistant',
                    content: this.strings.greeting,
                    asked_at: new Date().toISOString(),
                    chat_log_id: null,
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    AiChatApp.prototype.created = function () {
        var el = document.getElementById(this.configElementId);
        this.config = el ? JSON.parse(el.textContent || '{}') : null;
        if (this.config)
            this.selectedModelId = this.initialModelId();
    };
    // The model picked last time if the user may still use it, else the server's first choice.
    AiChatApp.prototype.initialModelId = function () {
        var remembered = null;
        try {
            remembered = Number(localStorage.getItem(this.config.storageKey + '_model')) || null;
        }
        catch (e) {
            /* ignore */
        }
        var usable = this.config.models.some(function (m) { return m.id === remembered; });
        return usable ? remembered : this.config.models.length ? this.config.models[0].id : null;
    };
    AiChatApp.prototype.onSelectModel = function (id) {
        this.selectedModelId = id;
        this.rememberModel();
    };
    // A reload restores the open session's id from localStorage but not its model.
    AiChatApp.prototype.restoreSessionModel = function () {
        var _this = this;
        if (this.currentSessionId === null)
            return;
        fetch("".concat(this.config.urls.sessions).concat(this.currentSessionId, "/"))
            .then(function (resp) { return (resp.ok ? resp.json() : null); })
            .then(function (data) {
            if (data)
                _this.applySessionModel(data);
        })
            .catch(function () { });
    };
    AiChatApp.prototype.rememberModel = function () {
        try {
            if (this.selectedModelId !== null) {
                localStorage.setItem(this.config.storageKey + '_model', String(this.selectedModelId));
            }
        }
        catch (e) {
            /* ignore */
        }
    };
    AiChatApp.prototype.mounted = function () {
        var _this = this;
        if (!this.config) {
            console.error('AI chat: config element not found (id: ' + this.configElementId + ')');
            return;
        }
        if (!this.loadHistory()) {
            // Nothing to restore — displayMessages already falls back to the greeting.
        }
        this.fetchSessions();
        this.restoreSessionModel();
        this.clockInterval = window.setInterval(function () {
            _this.clockTick++;
        }, 15000);
        this.$nextTick(function () { return _this.focusInput(); });
    };
    AiChatApp.prototype.beforeDestroy = function () {
        if (this.clockInterval)
            window.clearInterval(this.clockInterval);
    };
    // ── localStorage persistence ──
    AiChatApp.prototype.saveHistory = function () {
        try {
            var payload = { sessionId: this.currentSessionId, messages: this.chatHistory };
            localStorage.setItem(this.config.storageKey, JSON.stringify(payload));
        }
        catch (e) {
            /* ignore */
        }
    };
    AiChatApp.prototype.loadHistory = function () {
        try {
            var stored = localStorage.getItem(this.config.storageKey);
            if (!stored)
                return false;
            var parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) {
                // Back-compat: older versions stored the messages array directly.
                this.chatHistory = parsed;
                this.currentSessionId = null;
            }
            else {
                this.chatHistory = parsed.messages || [];
                this.currentSessionId = parsed.sessionId || null;
            }
            return this.chatHistory.length > 0;
        }
        catch (e) {
            this.chatHistory = [];
            return false;
        }
    };
    AiChatApp.prototype.scrollToBottom = function () {
        var el = this.$refs.messagesWrap;
        if (el)
            el.scrollTop = el.scrollHeight;
    };
    AiChatApp.prototype.focusInput = function () {
        var el = this.$refs.input;
        if (el)
            el.focus();
    };
    AiChatApp.prototype.autosize = function () {
        var el = this.$refs.input;
        if (!el)
            return;
        el.style.height = 'auto';
        el.style.height = Math.min(el.scrollHeight, 200) + 'px';
    };
    AiChatApp.prototype.onInputKeydown = function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            this.sendMessage();
        }
    };
    AiChatApp.prototype.onRated = function (message, rating) {
        // Patch chatHistory/localStorage too, not just the child's own local state —
        // this page's own reload replays from localStorage, not the server.
        message.rating = rating;
        this.saveHistory();
    };
    AiChatApp.prototype.deriveQuickTitle = function (text) {
        var words = text.trim().split(/\s+/).slice(0, 8).join(' ');
        return words.length > 80 ? words.slice(0, 79) + '…' : words;
    };
    AiChatApp.prototype.newRequestId = function () {
        return (window.crypto && window.crypto.randomUUID)
            ? window.crypto.randomUUID()
            : 'req-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    };
    AiChatApp.prototype.clearChat = function () {
        var _this = this;
        if (this.busy)
            return;
        this.chatHistory = [];
        this.currentSessionId = null;
        this.selectedModelId = this.initialModelId();
        this.sessionModel = null;
        this.sessionMode = null;
        this.planFirst = true;
        this.pendingFile = null;
        try {
            localStorage.removeItem(this.config.storageKey);
        }
        catch (e) {
            /* ignore */
        }
        this.errorMessage = null;
        this.$nextTick(function () {
            _this.scrollToBottom();
            _this.focusInput();
        });
        this.fetchSessions();
    };
    AiChatApp.prototype.fetchSessions = function () {
        var _this = this;
        fetch(this.config.urls.sessions, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (resp) { return (resp.ok ? resp.json() : { latest: [], favorites: [] }); })
            .then(function (data) {
            _this.sessions = { latest: data.latest || [], favorites: data.favorites || [] };
        })
            .catch(function () { });
    };
    AiChatApp.prototype.loadSession = function (id) {
        var _this = this;
        if (this.busy)
            return;
        // Closes the mobile drawer too (harmless no-op on desktop, where it's never
        // opened) — picking a session is the natural point to return to the chat.
        this.railOpen = false;
        fetch("".concat(this.config.urls.sessions).concat(id, "/"))
            .then(function (resp) { return resp.json(); })
            .then(function (data) {
            _this.currentSessionId = data.id;
            // The conversation's own model, shown (locked) in the picker.
            _this.applySessionModel(data);
            _this.chatHistory = (data.messages || []).slice();
            _this.saveHistory();
            _this.errorMessage = null;
            _this.$nextTick(_this.scrollToBottom);
            _this.fetchSessions();
        })
            .catch(function () {
            _this.errorMessage = _this.strings.couldNotLoad;
        });
    };
    AiChatApp.prototype.toggleFavorite = function (id) {
        var _this = this;
        fetch("".concat(this.config.urls.sessions).concat(id, "/favorite/"), {
            method: 'POST',
            headers: { 'X-CSRFToken': this.$getCsrfToken() },
        })
            .then(function () { return _this.fetchSessions(); })
            .catch(function () { });
    };
    AiChatApp.prototype.deleteSession = function (id) {
        var _this = this;
        if (!confirm(this.strings.deleteConfirm))
            return;
        fetch("".concat(this.config.urls.sessions).concat(id, "/delete/"), {
            method: 'POST',
            headers: { 'X-CSRFToken': this.$getCsrfToken() },
        })
            .then(function () {
            if (id === _this.currentSessionId)
                _this.clearChat();
            _this.fetchSessions();
        })
            .catch(function () { });
    };
    AiChatApp.prototype.clearPendingPlaceholder = function () {
        if (!this.pendingSessionTitle)
            return;
        this.pendingSessionTitle = null;
        this.fetchSessions();
    };
    AiChatApp.prototype.resetBusy = function () {
        var _this = this;
        this.busy = false;
        this.currentRequestId = null;
        this.currentAbortController = null;
        this.$nextTick(function () { return _this.focusInput(); });
    };
    AiChatApp.prototype.appendStreamDelta = function (delta) {
        var _this = this;
        this.streamBuffer += delta;
        if (this.streamFlushScheduled)
            return;
        this.streamFlushScheduled = true;
        requestAnimationFrame(function () {
            _this.streamFlushScheduled = false;
            if (!_this.streamingMessage)
                return;
            _this.streamingMessage.content = _this.streamBuffer;
            _this.scrollToBottom();
        });
    };
    AiChatApp.prototype.stopMessage = function () {
        if (!this.busy)
            return;
        if (this.deepInFlight) {
            // The run keeps streaming until the worker has saved what it had; the events
            // stream then ends with a "cancelled" event that sendDeepMessage handles.
            this.stopRequested = true;
            if (this.currentRunId !== null && this.currentSessionId !== null)
                this.cancelRun(this.currentSessionId, this.currentRunId);
            return;
        }
        var requestId = this.currentRequestId;
        if (this.currentAbortController)
            this.currentAbortController.abort();
        if (requestId) {
            fetch(this.config.urls.chatStop, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRFToken': this.$getCsrfToken() },
                body: JSON.stringify({ request_id: requestId }),
            }).catch(function () { });
        }
        this.showTyping = false;
        this.chatHistory.pop();
        this.saveHistory();
        this.clearPendingPlaceholder();
        this.resetBusy();
    };
    AiChatApp.prototype.sendMessage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var text, askedAt, typingHidden, hideTypingOnce, sawText, terminalType, terminalMessage, resp, errData, reader, decoder, buffer, chunk, sepIndex, frame, evt, replyAskedAt, assistantEntry, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.busy || this.lockedToFast)
                            return [2 /*return*/];
                        text = this.inputText.trim();
                        if (!text)
                            return [2 /*return*/];
                        this.errorMessage = null;
                        this.inputText = '';
                        this.$nextTick(this.autosize);
                        if (!this.deepActive) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.sendDeepMessage(text, false)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        askedAt = new Date().toISOString();
                        this.chatHistory.push({ role: 'user', content: text, asked_at: askedAt });
                        this.saveHistory();
                        this.$nextTick(this.scrollToBottom);
                        if (!this.currentSessionId) {
                            this.pendingSessionTitle = this.deriveQuickTitle(text);
                        }
                        this.busy = true;
                        this.currentRequestId = this.newRequestId();
                        this.currentAbortController = new AbortController();
                        this.showTyping = true;
                        typingHidden = false;
                        hideTypingOnce = function () {
                            if (!typingHidden) {
                                typingHidden = true;
                                _this.showTyping = false;
                            }
                        };
                        sawText = false;
                        terminalType = null;
                        terminalMessage = null;
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 10, , 11]);
                        return [4 /*yield*/, fetch(this.config.urls.chat, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'X-CSRFToken': this.$getCsrfToken() },
                                body: JSON.stringify({
                                    messages: this.chatHistory,
                                    session_id: this.currentSessionId,
                                    request_id: this.currentRequestId,
                                    model_id: this.selectedModelId,
                                }),
                                signal: this.currentAbortController.signal,
                            })];
                    case 4:
                        resp = _a.sent();
                        if (!(!resp.ok || !resp.body)) return [3 /*break*/, 6];
                        hideTypingOnce();
                        return [4 /*yield*/, resp.json().catch(function () { return ({}); })];
                    case 5:
                        errData = _a.sent();
                        this.errorMessage = errData.error || this.strings.genericError;
                        this.chatHistory.pop();
                        this.saveHistory();
                        this.clearPendingPlaceholder();
                        this.resetBusy();
                        return [2 /*return*/];
                    case 6:
                        reader = resp.body.getReader();
                        decoder = new TextDecoder();
                        buffer = '';
                        _a.label = 7;
                    case 7:
                        if (!true) return [3 /*break*/, 9];
                        return [4 /*yield*/, reader.read()];
                    case 8:
                        chunk = _a.sent();
                        if (chunk.done)
                            return [3 /*break*/, 9];
                        buffer += decoder.decode(chunk.value, { stream: true });
                        sepIndex = void 0;
                        while ((sepIndex = buffer.indexOf('\n\n')) !== -1) {
                            frame = buffer.slice(0, sepIndex);
                            buffer = buffer.slice(sepIndex + 2);
                            if (frame.indexOf('data: ') !== 0)
                                continue;
                            evt = void 0;
                            try {
                                evt = JSON.parse(frame.slice(6));
                            }
                            catch (e) {
                                continue;
                            }
                            if (evt.type === 'text_delta') {
                                if (!sawText) {
                                    sawText = true;
                                    hideTypingOnce();
                                    this.streamBuffer = '';
                                    this.streamingMessage = { role: 'assistant', content: '' };
                                }
                                this.appendStreamDelta(evt.text);
                            }
                            else if (evt.type === 'tool_call') {
                                // The typing dots stay up, labelled with the current step, until the
                                // answer text starts: a tool call is when the wait is longest.
                                this.liveSteps.push({ name: evt.name, label: evt.label });
                                this.$nextTick(this.scrollToBottom);
                            }
                            else if (evt.type === 'done') {
                                terminalType = 'done';
                                hideTypingOnce();
                                replyAskedAt = new Date().toISOString();
                                assistantEntry = {
                                    role: 'assistant',
                                    content: evt.answer,
                                    asked_at: replyAskedAt,
                                    chat_log_id: evt.chat_log_id,
                                };
                                if (evt.steps && evt.steps.length)
                                    assistantEntry.steps = evt.steps;
                                if (evt.grounding)
                                    assistantEntry.grounding = evt.grounding;
                                this.chatHistory.push(assistantEntry);
                                this.streamingMessage = null;
                                this.liveSteps = [];
                                if (evt.model_id)
                                    this.selectedModelId = evt.model_id;
                                if (evt.session_id) {
                                    this.currentSessionId = evt.session_id;
                                    this.sessionMode = 'fast';
                                    this.pendingSessionTitle = null;
                                    this.fetchSessions();
                                }
                                this.saveHistory();
                                this.$nextTick(this.scrollToBottom);
                            }
                            else if (evt.type === 'cancelled') {
                                terminalType = 'cancelled';
                            }
                            else if (evt.type === 'error') {
                                terminalType = 'error';
                                terminalMessage = evt.message;
                            }
                        }
                        return [3 /*break*/, 7];
                    case 9:
                        hideTypingOnce();
                        if (terminalType === 'cancelled') {
                            this.streamingMessage = null;
                            this.liveSteps = [];
                            if (this.busy) {
                                this.chatHistory.pop();
                                this.saveHistory();
                                this.clearPendingPlaceholder();
                            }
                        }
                        else if (terminalType === 'error') {
                            this.streamingMessage = null;
                            this.liveSteps = [];
                            this.errorMessage = terminalMessage || this.strings.genericError;
                            this.chatHistory.pop();
                            this.saveHistory();
                            this.clearPendingPlaceholder();
                        }
                        else if (terminalType !== 'done') {
                            // Connection closed without any terminal event.
                            this.streamingMessage = null;
                            this.liveSteps = [];
                            this.errorMessage = this.strings.networkError;
                            this.chatHistory.pop();
                            this.saveHistory();
                            this.clearPendingPlaceholder();
                        }
                        this.resetBusy();
                        return [3 /*break*/, 11];
                    case 10:
                        err_1 = _a.sent();
                        hideTypingOnce();
                        this.streamingMessage = null;
                        this.liveSteps = [];
                        if (err_1 && err_1.name === 'AbortError') {
                            // user-initiated stop already reset the UI/history in stopMessage()
                            return [2 /*return*/];
                        }
                        this.errorMessage = this.strings.networkError;
                        this.chatHistory.pop();
                        this.saveHistory();
                        this.clearPendingPlaceholder();
                        this.resetBusy();
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    // ── Deep mode ──
    AiChatApp.prototype.approvePlan = function () {
        if (this.busy)
            return;
        this.sendDeepMessage(this.strings.planApprovedMessage, true);
    };
    AiChatApp.prototype.deepErrorText = function (code, keyScope, resetAt) {
        var ownKey = keyScope === 'user';
        switch (code) {
            case 'quota_exhausted': {
                var date = resetAt ? new Date(resetAt) : null;
                return date && !isNaN(date.getTime())
                    ? this.strings.deepErrorToolQuota + ' ' + this.strings.deepErrorToolQuotaResets.replace('{date}', date.toLocaleDateString())
                    : this.strings.deepErrorToolQuota;
            }
            case 'provider_quota_exhausted':
                return ownKey ? this.strings.deepErrorQuotaUserKey : this.strings.deepErrorQuotaSharedKey;
            case 'provider_key_expired':
                return ownKey ? this.strings.deepErrorExpiredUserKey : this.strings.deepErrorExpiredSharedKey;
            case 'budget_exhausted':
            case 'wall_clock_exceeded':
                return this.strings.deepErrorBudget;
            case 'stale_run':
                return this.strings.deepErrorStale;
            case 'auth':
                return this.strings.deepErrorAuth;
            case 'rate_limit':
                return this.strings.deepErrorRateLimit;
            case 'no_api_key':
                return this.strings.deepErrorNoKey;
            case '5xx':
            case 'timeout':
            case 'connection_error':
                return this.strings.deepErrorService;
            default:
                return this.strings.genericError;
        }
    };
    AiChatApp.prototype.postJson = function (url, body) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'X-CSRFToken': this.$getCsrfToken() },
                            body: JSON.stringify(body),
                        })];
                    case 1:
                        resp = _a.sent();
                        return [4 /*yield*/, resp.json().catch(function () { return ({}); })];
                    case 2:
                        data = _a.sent();
                        if (!resp.ok)
                            throw new Error(data.error || this.strings.genericError);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    AiChatApp.prototype.cancelRun = function (sessionId, runId) {
        fetch(runUrl(this.config.urls.deepRunCancelTemplate, sessionId, runId), {
            method: 'POST',
            headers: { 'X-CSRFToken': this.$getCsrfToken() },
        }).catch(function () { });
    };
    AiChatApp.prototype.upsertDeepStep = function (step) {
        var steps = this.liveDeepSteps.filter(function (s) { return s.index !== step.index; });
        steps.push(step);
        steps.sort(function (a, b) { return a.index - b.index; });
        this.liveDeepSteps = steps;
    };
    // Shows streamed answer text once there is something to show — some models emit
    // whitespace-only text around their tool calls.
    AiChatApp.prototype.applyDeepText = function (text, replace) {
        this.streamBuffer = replace ? text : this.streamBuffer + text;
        if (!this.streamingMessage && this.streamBuffer.trim()) {
            this.showTyping = false;
            this.streamingMessage = { role: 'assistant', content: '', deep: true };
        }
        if (this.streamingMessage)
            this.appendStreamDelta('');
    };
    /**
     * Follows one run's event stream. Returns its terminal event, or null when the
     * connection closed without one (a proxy timeout, say) — the caller reconnects, and
     * the new connection's snapshot catches up.
     */
    AiChatApp.prototype.followRun = function (sessionId, runId) {
        return __awaiter(this, void 0, void 0, function () {
            var resp, data, reader, decoder, buffer, chunk, sepIndex, frame, evt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(runUrl(this.config.urls.deepRunEventsTemplate, sessionId, runId), {
                            credentials: 'same-origin',
                        })];
                    case 1:
                        resp = _a.sent();
                        if (!(!resp.ok || !resp.body)) return [3 /*break*/, 3];
                        return [4 /*yield*/, resp.json().catch(function () { return ({}); })];
                    case 2:
                        data = _a.sent();
                        throw new Error(data.error || this.strings.genericError);
                    case 3:
                        reader = resp.body.getReader();
                        decoder = new TextDecoder();
                        buffer = '';
                        _a.label = 4;
                    case 4:
                        if (!true) return [3 /*break*/, 6];
                        return [4 /*yield*/, reader.read()];
                    case 5:
                        chunk = _a.sent();
                        if (chunk.done)
                            return [2 /*return*/, null];
                        buffer += decoder.decode(chunk.value, { stream: true });
                        sepIndex = void 0;
                        while ((sepIndex = buffer.indexOf('\n\n')) !== -1) {
                            frame = buffer.slice(0, sepIndex);
                            buffer = buffer.slice(sepIndex + 2);
                            if (frame.indexOf('data: ') !== 0)
                                continue;
                            evt = void 0;
                            try {
                                evt = JSON.parse(frame.slice(6));
                            }
                            catch (e) {
                                continue;
                            }
                            if (evt.snapshot) {
                                this.liveDeepSteps = (evt.snapshot.steps || []).slice().sort(function (a, b) { return a.index - b.index; });
                                this.applyDeepText(evt.snapshot.answer || '', true);
                            }
                            else if (evt.step) {
                                this.upsertDeepStep(evt.step);
                                this.$nextTick(this.scrollToBottom);
                            }
                            else if (evt.delta) {
                                this.applyDeepText(evt.delta, false);
                            }
                            else if (evt.done || evt.error) {
                                try {
                                    reader.cancel();
                                }
                                catch (e) {
                                    /* ignore */
                                }
                                return [2 /*return*/, evt];
                            }
                        }
                        return [3 /*break*/, 4];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * A deep turn: create the session if this is the first message, upload the attachment,
     * start a background run and follow its events until it finishes.
     */
    AiChatApp.prototype.sendDeepMessage = function (text, approvePlan) {
        return __awaiter(this, void 0, void 0, function () {
            var userMessage, finish, fail, created, sessionId, outgoing, form, resp, uploaded, started, terminal, attempt, answer, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.errorMessage = null;
                        userMessage = { role: 'user', content: text, asked_at: new Date().toISOString() };
                        this.chatHistory.push(userMessage);
                        this.saveHistory();
                        this.$nextTick(this.scrollToBottom);
                        this.busy = true;
                        this.deepInFlight = true;
                        this.stopRequested = false;
                        this.currentRunId = null;
                        this.showTyping = true;
                        this.liveDeepSteps = [];
                        this.streamingMessage = null;
                        this.streamBuffer = '';
                        finish = function () {
                            _this.showTyping = false;
                            _this.streamingMessage = null;
                            _this.liveDeepSteps = [];
                            _this.currentRunId = null;
                            _this.deepInFlight = false;
                            _this.saveHistory();
                            _this.$nextTick(_this.scrollToBottom);
                            _this.resetBusy();
                        };
                        fail = function (message) {
                            _this.errorMessage = message;
                            _this.chatHistory.pop();
                            finish();
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 14, , 15]);
                        if (!(this.currentSessionId === null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.postJson(this.config.urls.deepSessionCreate, {
                                message: text,
                                model_id: this.selectedModelId,
                                mode: this.planFirst ? 'deep_planned' : 'deep',
                            })];
                    case 2:
                        created = _a.sent();
                        this.currentSessionId = created.session_id;
                        this.sessionMode = created.mode;
                        this.rememberModel();
                        this.saveHistory();
                        this.fetchSessions();
                        _a.label = 3;
                    case 3:
                        sessionId = this.currentSessionId;
                        outgoing = text;
                        if (!this.pendingFile) return [3 /*break*/, 6];
                        form = new FormData();
                        form.append('file', this.pendingFile);
                        return [4 /*yield*/, fetch(sessionUrl(this.config.urls.deepUploadTemplate, sessionId), {
                                method: 'POST',
                                headers: { 'X-CSRFToken': this.$getCsrfToken() },
                                body: form,
                            })];
                    case 4:
                        resp = _a.sent();
                        return [4 /*yield*/, resp.json().catch(function () { return ({}); })];
                    case 5:
                        uploaded = _a.sent();
                        if (!resp.ok)
                            throw new Error(uploaded.error || this.strings.genericError);
                        this.pendingFile = null;
                        // The load_file tool works on the upload's id; the model learns it from the message.
                        outgoing += "\n\n[Attached file \"".concat(uploaded.filename, "\" \u2014 parse it with load_file(\"").concat(uploaded.file_id, "\")]");
                        userMessage.content = outgoing;
                        this.saveHistory();
                        _a.label = 6;
                    case 6: return [4 /*yield*/, this.postJson(sessionUrl(this.config.urls.deepRunStartTemplate, sessionId), {
                            message: outgoing,
                            approve_plan: approvePlan,
                        })];
                    case 7:
                        started = _a.sent();
                        this.currentRunId = started.run_id;
                        if (this.stopRequested)
                            this.cancelRun(sessionId, started.run_id);
                        terminal = null;
                        attempt = 0;
                        _a.label = 8;
                    case 8:
                        if (!(!terminal && attempt <= 3)) return [3 /*break*/, 13];
                        if (!(attempt > 0)) return [3 /*break*/, 10];
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 1000); })];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10: return [4 /*yield*/, this.followRun(sessionId, started.run_id)];
                    case 11:
                        terminal = _a.sent();
                        _a.label = 12;
                    case 12:
                        attempt++;
                        return [3 /*break*/, 8];
                    case 13:
                        if (!terminal) {
                            fail(this.strings.networkError);
                            return [2 /*return*/];
                        }
                        if (terminal.error) {
                            fail(this.deepErrorText(terminal.error_code, terminal.key_scope, terminal.reset_at));
                            return [2 /*return*/];
                        }
                        if (terminal.cancelled && terminal.session_id === undefined) {
                            // Stopped before it started: nothing was saved, so the question goes too.
                            this.chatHistory.pop();
                            finish();
                            return [2 /*return*/];
                        }
                        answer = {
                            role: 'assistant',
                            content: terminal.answer !== undefined ? terminal.answer : this.streamBuffer,
                            asked_at: new Date().toISOString(),
                            chat_log_id: terminal.chat_log_id === undefined ? null : terminal.chat_log_id,
                            deep: true,
                            deep_steps: terminal.deep_steps || this.liveDeepSteps,
                        };
                        if (terminal.plan)
                            answer.plan = terminal.plan;
                        if (terminal.needs_input)
                            answer.needs_input = true;
                        if (terminal.truncated)
                            answer.truncated = true;
                        if (terminal.loop_stopped)
                            answer.loop_stopped = true;
                        if (terminal.cancelled)
                            answer.was_cancelled = true;
                        this.chatHistory.push(answer);
                        if (terminal.title)
                            this.fetchSessions();
                        finish();
                        return [3 /*break*/, 15];
                    case 14:
                        err_2 = _a.sent();
                        fail(err_2 instanceof TypeError ? this.strings.networkError : (err_2 && err_2.message) || this.strings.genericError);
                        return [3 /*break*/, 15];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ type: String, required: true })
    ], AiChatApp.prototype, "configElementId", void 0);
    AiChatApp = __decorate([
        Component({
            components: { MessageBubble: MessageBubble, StepsCollapsible: StepsCollapsible, SessionSidebar: SessionSidebar, ConnectionsPanel: ConnectionsPanel, ModelPanel: ModelPanel, DeepSteps: DeepSteps },
        })
    ], AiChatApp);
    return AiChatApp;
}(Vue));
export default AiChatApp;
